import { z } from 'zod';
import { FromSchema } from '@40seas/entities/common';
import { StripeIdentityIdNumber, StripeIdentityIdNumberSchema } from './stripe.identity.id-number.entity';
import { StripeIdentityDocument, StripeIdentityDocumentSchema } from './stripe.identity.document.entity';

export const StripeIdentitySchema = z
    .object({
        document: StripeIdentityDocumentSchema.optional(),
        idNumber: StripeIdentityIdNumberSchema.optional(),
    })
    .strict();

export class StripeIdentity extends FromSchema(StripeIdentitySchema) {
    document?: StripeIdentityDocument;
    idNumber?: StripeIdentityIdNumber;
}
